<template>
  <modal
    name="camera-permission-modal"
    height="auto"
    :focus-trap="true"
    :scrollable="true"
    :draggable="true"
    :adaptive="true"
    :reset="true"
    >
    <div class="p-2">
      <h1 class="mb-1">Media Access Error<span v-if="permissionError">: Permission Denied</span></h1>

      <p>
        There was an error accessing your camera and audio for making the video call. <br />
        This may be due to
        <ul>
          <li>No camera detected on your device</li>
          <li>You've denied this website access to your cameras.</li>
        </ul>
      </p>

      <p class="mt-1">
        If you've denied this website access to your cameras and audio. <br />
        Follow the instructions below to allow access to your camera and speaker
      </p>
  
      <div>
        <div class="my-2">
          <h3>Chrome Instructions</h3>
          <p>
            If you're using google chrome,
            <a href="https://support.google.com/chrome/answer/2693767" target="_blank">click here</a>
            to find out more about how you may allow camera permission for our
            website
          </p>
        </div>
  
        <div>
          <h3>Firefox Instructions</h3>
          <p>
            If you're using google chrome,
            <a href="https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions"
              target="_blank"
              >click here</a>
            to find out more about how you may allow camera permission for our
            website
          </p>
        </div>
  
        <div class="my-2">
          <h3>Other browsers</h3>
          <p>
            Use a google search to find instructions on how to allow camera
            permissions for your browser.
          </p>
        </div>
      </div>

      <h3 class="text-center">Camera Availability Troubleshooting</h3>
      <p class="mt-1">
        If our app cannot access your camera or speaker, it is likely because you may have a camera or speaker issue.
        Test you webcam or other attached cameras to ensure they are accessible and functional and try again.
        If your issue persists, contact support.
      </p>
    </div>
  </modal>
</template>
<script>
import { BModal } from "bootstrap-vue"

export default {
  components: { BModal },
  props: {
    showCameraInstructionModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    permissionError: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  methods: {
    changeVisibility(visible = false) {
      this.$emit('update:is-import-file-active', visible)
    }
  }
}
</script>
<style></style>
